import api from "./api";
import capi from "./consumerApi";
import papi from "./proApi";

const REALMS = {
  firm: { inst: api, path: "/track", key: "lm_token" },
  consumer: { inst: capi, path: "/consumer/track", key: "lx_consumer_token" },
  pro: { inst: papi, path: "/pro/track", key: "lx_pro_token" },
};

function makeSid() {
  let s = sessionStorage.getItem("lx_sid");
  if (!s) { s = (window.crypto?.randomUUID?.() || String(Date.now()) + Math.random()); sessionStorage.setItem("lx_sid", s); }
  return s;
}

// Starts lightweight page-view + click + heartbeat tracking for one realm.
export function startTracker(realm) {
  const r = REALMS[realm];
  if (!r || typeof window === "undefined") return () => {};
  const sid = makeSid();
  const send = (body) => {
    if (!localStorage.getItem(r.key)) return;
    r.inst.post(r.path, { ...body, session_id: sid }).catch(() => {});
  };
  let last = null;
  const pv = () => {
    const p = window.location.pathname + window.location.search;
    if (p === last) return; last = p;
    send({ type: "page_view", path: p });
  };
  const onClick = (e) => {
    const el = e.target?.closest?.("[data-testid],button,a");
    if (!el) return;
    const testid = el.getAttribute?.("data-testid") || "";
    const label = (el.getAttribute?.("aria-label") || el.textContent || "").trim().slice(0, 80);
    send({ type: "click", path: window.location.pathname, testid, label });
  };
  const hb = () => send({ type: "heartbeat", path: window.location.pathname });
  pv();
  const iv = setInterval(() => { pv(); hb(); }, 20000);
  document.addEventListener("click", onClick, true);
  window.addEventListener("popstate", pv);
  const op = window.history.pushState;
  window.history.pushState = function (...a) { const res = op.apply(this, a); setTimeout(pv, 0); return res; };
  return () => {
    clearInterval(iv);
    document.removeEventListener("click", onClick, true);
    window.removeEventListener("popstate", pv);
    window.history.pushState = op;
  };
}
